import React from 'react';
import style from './LabelledButtonBar.scss';
export const LabelledButtonBar = (props) => (React.createElement("div", { className: style.labelledButtonBar },
    React.createElement("div", { className: style.label }, props.label),
    React.createElement("div", { className: style.buttonbar }, props.buttons)));
